/**
 * Safe localStorage wrapper for Safari iOS compatibility
 * Prevents SecurityError in private browsing mode or restricted contexts
 */
const storage = {
  getItem: (key: string): string | null => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.warn(`localStorage.getItem("${key}") failed:`, error);
      return null;
    }
  },
  setItem: (key: string, value: string): void => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.warn(`localStorage.setItem("${key}") failed:`, error);
    }
  },
  removeItem: (key: string): void => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn(`localStorage.removeItem("${key}") failed:`, error);
    }
  },
};

export default storage;
